/*
* @描述: 添加版本
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-01-17 10:52:24
*/
<template>
    <el-drawer size="35%"
               :wrapperClosable="false"
               :visible.sync="editVisible"
               :close-on-press-escape="false"
               :destroy-on-close="true"
               :with-header="false">
        <div class="drawer_wrap" v-loading="loading">
            <div class="drawer_header">
                <h3 class="title">编辑版本号</h3>
                <i class="el-icon-close" @click="handleClickCancel"></i>
            </div>
            <div class="drawer_body">
                <el-form :model="versionForm"
                         :rules="versionFormRules"
                         label-position="top"
                         ref="versionForm"
                         size="small">
                    <el-form-item label="版本号" prop="version">
                        <el-input placeholder="请输入版本名称" v-model="versionForm.version" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="上线时间" prop="upper_date">
                        <el-date-picker format="yyyy-MM-dd"
                                        placeholder="请选择上线日期"
                                        type="date"
                                        v-model="versionForm.upper_date"
                                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="版本内容" prop="content">
                        <el-input :rows="15"
                                  placeholder="请输入版本内容"
                                  type="textarea"
                                  v-model="versionForm.content"
                                  show-word-limit
                                  maxlength="1000"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="drawer_footer">
                <el-button @click="handleClickCancel" size="small">取消</el-button>
                <el-button :disabled="btnDisabled" @click="handleClickConfirm" size="small" type="primary">保存
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>
<script>
    import {editVersion, getVersionDetails} from "@/api";

    export default {
        name: "",
        props: {
            editVisible: {
                type: Boolean,
                default: false,
            },
            versionId: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                loading: false,
                btnDisabled: false,
                versionForm: {
                    version: '',
                    content: '',
                    upper_date: '',
                    id: '',
                },
                versionFormRules: {
                    version: [
                        {required: true, message: '请输入版本名称', trigger: 'blur'},
                    ],
                    content: [
                        {required: true, message: '请输入版本内容', trigger: 'blur'},
                    ],
                    upper_date: [
                        {required: true, message: '请选择上线日期', trigger: 'blur'},
                    ],
                },
            }
        },
        created() {
            if (this.versionId !== 0) {
                this.versionForm.version_id = this.versionId
                this.loading = true
                this.getVersionDetail()
            }
        },
        mounted() {
        },
        methods: {
            getVersionDetail() {
                getVersionDetails({
                    version_id: this.versionForm.version_id,
                }).then(res => {
                    this.versionForm = res.data
                    this.loading = false
                })
            },

            handleClickCancel() {
                this.$refs.versionForm.resetFields()
                this.$emit('update:editVisible', false)
            },

            handleClickConfirm() {
                this.$refs.versionForm.validate(valid => {
                    if (valid) {
                        this.btnDisabled = true
                        editVersion({
                            version: this.versionForm.version,
                            content: this.versionForm.content,
                            upper_date: this.versionForm.upper_date,
                            version_id: this.versionForm.version_id
                        }).then(res => {
                            this.$message.success('编辑成功')
                            this.$emit('success')
                            this.$refs.versionForm.resetFields()
                            this.$emit('update:editVisible', false)
                        }).catch(() => {
                            this.btnDisabled = false
                        })
                    } else {
                        return false
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
  .el-date-editor.el-input {
    width: 100%;
  }

</style>
